import { render } from "./adddevices.vue?vue&type=template&id=470ebadf&scoped=true"
import script from "./adddevices.vue?vue&type=script&lang=js"
export * from "./adddevices.vue?vue&type=script&lang=js"

import "./adddevices.vue?vue&type=style&index=0&id=470ebadf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ebadf"]])

export default __exports__